import {FC, useState, createContext, useContext, Dispatch, SetStateAction} from 'react'

import {WithChildren} from '../../../../_metronic/helpers'

interface DataRoomShareLink {
  id: number
  aclList: string
}
interface DataroomContent {
  dataroom_contentId: number
  isHidden: boolean
  isTrash: boolean
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  dataRoomId: number
  contentId: number
}

interface User {
  firstName: string
  lastName: string
  profileImage: number
  file: {
    fileId: number
    name: string
    isProtected: boolean
    module: string
    createdAt: string
    updatedAt: string
    deletedAt: string | null
    companyId: number | null
    userId: number
  }
}

interface DataRoomLogo {
  fileId: number
  name: string
  isProtected: boolean
  module: string
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  companyId: number | null
  userId: number
}

interface DataRooms {
  dataRoomId: number
  title: string
  subtitle: string
  status: string
  createdAt: string
  updatedAt: string
  companyId: number
  userId: number
  logoId: number
  bannerId: number
  data_Room_Share_Links: DataRoomShareLink[]
  contents: {
    contentId: number
    visits: any[]
    dataroom_content: DataroomContent
  }[]
  user: User
  dataRoomLogo: DataRoomLogo
  sharedWith: any[]
  contentCount: number
  visitsCount: number
}

interface AllRoomDataResponse {
  modifiedDataRooms: DataRooms[]
}

type MoveToFolderProps = {
  contentID: string | undefined
  storecontentID: Dispatch<SetStateAction<string | undefined>>
  showDrawer: boolean | undefined
  setShowDrawer: Dispatch<SetStateAction<boolean | undefined>>
  showOptionsDrawer: boolean | undefined
  setShowOptionsDrawer: Dispatch<SetStateAction<boolean | undefined>>
  addUrlDrawer: boolean | undefined
  setAddUrlDrawer: Dispatch<SetStateAction<boolean | undefined>>
  addUploadDrawer: boolean | undefined
  setAddUploadDrawer: Dispatch<SetStateAction<boolean | undefined>>
  folderNameErr: boolean | undefined
  setFolderNameErr: Dispatch<SetStateAction<boolean | undefined>>
  filesContentId: string
  setFilesContentId: Dispatch<SetStateAction<string>>
  breadcrumbContentId: string
  setBreadcrumbContentId: Dispatch<SetStateAction<string>>
  shareDrawer: boolean
  setShareDrawer: Dispatch<SetStateAction<boolean>>
  breadCrumbLatestElementId: string
  setBreadCrumbLatestElementId: Dispatch<SetStateAction<string>>
  restrictAccessDrawer: boolean
  setRestrictAcessDrawer: Dispatch<SetStateAction<boolean>>
  linkCreatedModal: boolean
  setLinkCreatedModal: Dispatch<SetStateAction<boolean>>
  createLinkDrawer: boolean
  setCreateLinkDrawer: Dispatch<SetStateAction<boolean>>
  showAddContentDrawer: boolean | undefined
  setShowAddContentDrawer: Dispatch<SetStateAction<boolean | undefined>>
  refreshFuncBool: boolean | undefined
  setRefreshFuncBool: Dispatch<SetStateAction<boolean | undefined>>
  shareLinkApiData: any[]
  setShareLinkApiData: Dispatch<SetStateAction<any[]>>
  shareLinkApiLoading: boolean
  setShareLinkApiLoading: Dispatch<SetStateAction<boolean>>
  dataRoomApiLoading: boolean
  setdataRoomApiLoading: Dispatch<SetStateAction<boolean>>
  allRoomData: AllRoomDataResponse | undefined
  setAllRoomData: Dispatch<SetStateAction<AllRoomDataResponse | undefined>>
  dataRoomStatus: string
  setDataRoomStatus: Dispatch<SetStateAction<string>>
  searchValue: string
  setSearchValue: Dispatch<SetStateAction<string>>
  refreshFuncBoolDr: boolean | undefined
  setRefreshFuncBoolDr: Dispatch<SetStateAction<boolean | undefined>>
  oneDropdownOpenBool: boolean | undefined
  setOneDropdownOpenBool: Dispatch<SetStateAction<boolean | undefined>>
  refreshFuncBoolAddToSpace: boolean | undefined
  setRefreshFuncBoolAddToSpace: Dispatch<SetStateAction<boolean | undefined>>
  createdFolderContentId: number | undefined
  setCreatedFolderContentId: Dispatch<SetStateAction<number | undefined>>
  dataRoomLatestBreadcrumbId: number | null
  setDataRoomLatestBreadcrumbId: Dispatch<SetStateAction<number | null>>
  dataRoomLatestBreadcrumbContentId: number | null
  setDataRoomLatestBreadcrumbContentId: Dispatch<SetStateAction<number | null>>
  contentName: string
  setContentName: Dispatch<SetStateAction<string>>
  signURLContext:string
  setSignURLContext :Dispatch<SetStateAction<string>>
  addLoaderMoveToFolder: boolean | undefined
  setAddLoaderMoveToFolder: Dispatch<SetStateAction<boolean | undefined>>
}

const initMoveToFolderPropsState = {
  contentID: undefined,
  storecontentID: () => {},
  showDrawer: undefined,
  setShowDrawer: () => {},
  showOptionsDrawer: undefined,
  setShowOptionsDrawer: () => {},
  addUrlDrawer: undefined,
  setAddUrlDrawer: () => {},
  addUploadDrawer: undefined,
  setAddUploadDrawer: () => {},
  folderNameErr: undefined,
  setFolderNameErr: () => {},
  filesContentId: '',
  setFilesContentId: () => {},
  breadcrumbContentId: '',
  setBreadcrumbContentId: () => {},
  shareDrawer: false,
  setShareDrawer: () => {},
  breadCrumbLatestElementId: '',
  setBreadCrumbLatestElementId: () => {},
  showAddContentDrawer: undefined,
  setShowAddContentDrawer: () => {},
  refreshFuncBool: undefined,
  setRefreshFuncBool: () => {},
  restrictAccessDrawer: false,
  setRestrictAcessDrawer: () => {},
  createLinkDrawer: false,
  setCreateLinkDrawer: () => {},
  linkCreatedModal: false,
  setLinkCreatedModal: () => {},
  shareLinkApiData: [],
  setShareLinkApiData: () => {},
  shareLinkApiLoading: false,
  setShareLinkApiLoading: () => {},
  dataRoomApiLoading: false,
  setdataRoomApiLoading: () => {},
  allRoomData: undefined,
  setAllRoomData: () => {},
  dataRoomStatus: '',
  setDataRoomStatus: () => {},
  searchValue: '',
  setSearchValue: () => {},
  refreshFuncBoolDr: undefined,
  setRefreshFuncBoolDr: () => {},
  oneDropdownOpenBool: undefined,
  setOneDropdownOpenBool: () => {},
  refreshFuncBoolAddToSpace: undefined,
  setRefreshFuncBoolAddToSpace: () => {},
  createdFolderContentId: undefined,
  setCreatedFolderContentId: () => {},
  dataRoomLatestBreadcrumbId: null,
  setDataRoomLatestBreadcrumbId: () => {},
  dataRoomLatestBreadcrumbContentId: null,
  setDataRoomLatestBreadcrumbContentId: () => {},
  contentName: '',
  setContentName: () => {},
  signURLContext:'',
  setSignURLContext :()=>{},
  addLoaderMoveToFolder: undefined,
  setAddLoaderMoveToFolder: ()=>{}
}

const MoveToFolderContext = createContext<MoveToFolderProps>(initMoveToFolderPropsState)

const useMoveToFolderData = () => {
  return useContext(MoveToFolderContext)
}

const MoveToFolderDataProvider: FC<WithChildren> = ({children}) => {
  const [contentID, storecontentID] = useState<string | undefined>()
  const [showDrawer, setShowDrawer] = useState<boolean | undefined>()
  const [showOptionsDrawer, setShowOptionsDrawer] = useState<boolean | undefined>()
  const [addUrlDrawer, setAddUrlDrawer] = useState<boolean | undefined>()
  const [addUploadDrawer, setAddUploadDrawer] = useState<boolean | undefined>()
  const [folderNameErr, setFolderNameErr] = useState<boolean | undefined>()
  const [filesContentId, setFilesContentId] = useState<string>('')
  const [breadcrumbContentId, setBreadcrumbContentId] = useState<string>('')
  const [shareDrawer, setShareDrawer] = useState<boolean>(false)
  const [restrictAccessDrawer, setRestrictAcessDrawer] = useState<boolean>(false)
  const [linkCreatedModal, setLinkCreatedModal] = useState<boolean>(false)
  const [createLinkDrawer, setCreateLinkDrawer] = useState<boolean>(false)
  const [breadCrumbLatestElementId, setBreadCrumbLatestElementId] = useState<string>('')
  const [showAddContentDrawer, setShowAddContentDrawer] = useState<boolean | undefined>()
  const [refreshFuncBool, setRefreshFuncBool] = useState<boolean | undefined>()
  const [shareLinkApiData, setShareLinkApiData] = useState<any>([])
  const [shareLinkApiLoading, setShareLinkApiLoading] = useState(false)
  const [dataRoomApiLoading, setdataRoomApiLoading] = useState(false)
  const [allRoomData, setAllRoomData] = useState<AllRoomDataResponse | undefined>()
  const [dataRoomStatus, setDataRoomStatus] = useState<string>('')
  const [searchValue, setSearchValue] = useState('')
  const [refreshFuncBoolDr, setRefreshFuncBoolDr] = useState<boolean | undefined>()
  const [oneDropdownOpenBool, setOneDropdownOpenBool] = useState<boolean | undefined>()
  const [refreshFuncBoolAddToSpace, setRefreshFuncBoolAddToSpace] = useState<boolean | undefined>()
  const [createdFolderContentId, setCreatedFolderContentId] = useState<number | undefined>()
  const [dataRoomLatestBreadcrumbId, setDataRoomLatestBreadcrumbId] = useState<number | null>(null)
  const [dataRoomLatestBreadcrumbContentId, setDataRoomLatestBreadcrumbContentId] = useState<number | null>(null)
  const [contentName, setContentName] = useState<string>('')
  const [signURLContext, setSignURLContext] = useState<string>('')
  const[addLoaderMoveToFolder,setAddLoaderMoveToFolder]=useState<boolean | undefined>()

  return (
    <MoveToFolderContext.Provider
      value={{
        contentID,
        storecontentID,
        showDrawer,
        setShowDrawer,
        showOptionsDrawer,
        setShowOptionsDrawer,
        addUrlDrawer,
        setAddUrlDrawer,
        addUploadDrawer,
        setAddUploadDrawer,
        folderNameErr,
        setFolderNameErr,
        filesContentId,
        setFilesContentId,
        breadcrumbContentId,
        setBreadcrumbContentId,
        shareDrawer,
        setShareDrawer,
        restrictAccessDrawer,
        setRestrictAcessDrawer,
        linkCreatedModal,
        setLinkCreatedModal,
        createLinkDrawer,
        setCreateLinkDrawer,
        breadCrumbLatestElementId,
        setBreadCrumbLatestElementId,
        showAddContentDrawer,
        setShowAddContentDrawer,
        refreshFuncBool,
        setRefreshFuncBool,
        shareLinkApiData,
        setShareLinkApiData,
        shareLinkApiLoading,
        setShareLinkApiLoading,
        dataRoomApiLoading,
        setdataRoomApiLoading,
        allRoomData,
        setAllRoomData,
        dataRoomStatus,
        setDataRoomStatus,
        searchValue,
        setSearchValue,
        refreshFuncBoolDr,
        setRefreshFuncBoolDr,
        oneDropdownOpenBool,
        setOneDropdownOpenBool,
        refreshFuncBoolAddToSpace,
        setRefreshFuncBoolAddToSpace,
        createdFolderContentId,
        setCreatedFolderContentId,
        dataRoomLatestBreadcrumbId,
        setDataRoomLatestBreadcrumbId,
        dataRoomLatestBreadcrumbContentId,
        setDataRoomLatestBreadcrumbContentId,
        contentName,
        setContentName,
        signURLContext,
        setSignURLContext ,
        addLoaderMoveToFolder,
        setAddLoaderMoveToFolder
      }}
    >
      {children}
    </MoveToFolderContext.Provider>
  )
}

export {MoveToFolderDataProvider, useMoveToFolderData}
